import { render, staticRenderFns } from "./OrderModifyCollector.vue?vue&type=template&id=88583fda&scoped=true"
import script from "./OrderModifyCollector.vue?vue&type=script&lang=js"
export * from "./OrderModifyCollector.vue?vue&type=script&lang=js"
import style0 from "./OrderModifyCollector.vue?vue&type=style&index=0&id=88583fda&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88583fda",
  null
  
)

export default component.exports